var map = {
	"./elephant_ui_disappointed": 1294,
	"./elephant_ui_disappointed.svg": 1294,
	"./elephant_ui_working": 1093,
	"./elephant_ui_working.svg": 1093,
	"./glitch-preview": 1295,
	"./glitch-preview.jpg": 1295,
	"./logo_warn_glitch": 1024,
	"./logo_warn_glitch.svg": 1024,
	"./mbstobon-ui-0": 1296,
	"./mbstobon-ui-0.png": 1296,
	"./mbstobon-ui-1": 1297,
	"./mbstobon-ui-1.png": 1297,
	"./mbstobon-ui-2": 1298,
	"./mbstobon-ui-2.png": 1298,
	"./mbstobon-ui-3": 1299,
	"./mbstobon-ui-3.png": 1299,
	"./wave-drawer": 1300,
	"./wave-drawer-glitched": 1301,
	"./wave-drawer-glitched.png": 1301,
	"./wave-drawer.png": 1300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1352;